<template>
  <div class="navList">
    <div class="list" v-for="(item, index) in Routers" :key='index' :class="{ listYs: activeIndex == item.name }"
      @click="routerChange(item)">
      <div class="text">{{ item.meta.name }}</div>
      <div class="xian"></div>
    </div>
    <div class="loginBox" @click="openLogin">
      <img class="img" src="@/assets/gytb/loginImg.png" alt="" />
      <div class="text">ログイン</div>
    </div>
  </div>
</template>

<script>
import sliderPath from '@/router/silderPath.js'
import routers from '@/router/index.js'
import deepClone from '../../utils/index.js'
import {
  eventBus
} from '../../utils/eventBus.js'
export default {
  data() {
    return {
      Routers: sliderPath,
      activeIndex: 'ja'
    }
  },
  computed: {
    filterRouter() {
      let newRouter = this.Routers
      return newRouter
    }
  },
  created() {
    // this.activeIndex = 'indexa'
    eventBus.$off('changeNavTitle')
    eventBus.$on('changeNavTitle', res => {
      console.log(res, 334455);
      this.activeIndex = this.Routers[res].name
      this.$router.push(this.Routers[res].path)
    })
  },
  mounted() {
    let name = this.$route.path.split('/')[1]
    this.activeIndex = name
  },
  methods: {
    // 跳转路由
    routerChange(item) {
      if (item.path == this.$route.path) return
      this.activeIndex = item.name
      this.$router.push(item.path)
    },

    // 打开登录
    openLogin() {
      this.$emit('openLogin', true)
    },
  }
}
</script>
<style lang="less" scoped>
.navList {
  display: flex;
  // align-items: center;
  // overflow-x: auto;
  height: 100%;

  .list {
    margin-right: 86px;
    position: relative;
    display: flex;
    align-items: center;

    &.listYs {
      .text {
        color: #0B6BB8;
      }

      .xian {
        background: #0B6BB8;
      }
    }

    .text {
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #1D2224;
      line-height: 28px;
      white-space: nowrap;
    }

    .xian {
      height: 8px;
      border-radius: 0px 0px 0px 0px;
      position: absolute;
      bottom: 0;
      width: -webkit-fill-available;
    }
  }

  .loginBox {
    display: flex;
    align-items: center;
    margin-left: 48px;
    min-width: 146px;
    height: 52px;
    border-radius: 182px 182px 182px 182px;
    border: 1px solid rgba(29, 34, 36, 0.2);
    padding: 0 12px;
    align-self: center;

    .img {
      width: 36px;
      height: 36px;
      margin-right: 8px;
      flex-shrink: 0;
    }

    .text {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 20px;
      color: #1D2224;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/aside.vue